<template>
    <div class="weeduc-admin-page corporate-page text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage :title="title" :subtitle="subtitle" :hasMargin="false" />
            </div>
        </header>
        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <div class="corporate-placeholder">
                    {{ t.placeholder.comingSoon }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitlePage from '@/components/Weflix/titlePage.vue';
import { corporateI18n } from '@/i18n/mixins';

export default {
    name: 'CorporatePlaceholderPage',
    mixins: [corporateI18n],
    components: { TitlePage },
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, required: true },
    },
};
</script>

<style scoped>
@import '@/css/weeduc/admin/corporate.css';
</style>
